/**
 * Can this org customise its PDF report (drop the methodology pages, drop the
 * "Powered by Zilch" mark)? Professional and Enterprise only.
 *
 * Lives here rather than inline in Profile.js because of the third rule below,
 * which is subtle and was worth getting wrong once: an API that predates the
 * feature returns no `can_customise_report` at all, and a *missing* flag is not
 * a "no". Reading absence as denial locks a paying customer out of the setting
 * and shows them an "upgrade to Professional" prompt for a plan they already
 * have — which is exactly what a frontend deploy landing ahead of the API
 * produced in production.
 *
 * The server re-checks the entitlement on write and again when the PDF renders,
 * so being optimistic here can only ever surface an honest 403 instead of a
 * silent dead end.
 *
 * @param {object|null} billing  /api/billing/status payload, or null while it loads
 * @param {boolean} isOverride   Zilch staff acting with full access
 * @returns {boolean}
 */
export function canCustomiseReport(billing, isOverride = false) {
  if (isOverride) return true;
  if (typeof billing?.can_customise_report === 'boolean') return billing.can_customise_report;
  // Flag absent: fall back to the plan, which every version of the API returns.
  const plan = billing?.plan;
  return plan === 'pro' || plan === 'enterprise';
}

export default canCustomiseReport;
